const Other = () => {
  return <div>Other</div>;
};

export default Other;
